// "Exportar a Excel" de los reportes (D95): arma el .xlsx al hacer clic, con una hoja por tabla.
import { Icon } from '../lib/icons';
import { descargarXlsx, type Hoja } from '../lib/xlsx';
import { toast } from './toasts';

export function BotonExcel({ archivo, hojas, disabled }: { archivo: string; hojas: () => Hoja[]; disabled?: boolean }) {
  const bajar = () => {
    try {
      descargarXlsx(archivo, hojas());
    } catch (e) {
      toast(`No se pudo armar el Excel: ${(e as Error).message}`, 'error');
    }
  };
  return (
    <button type="button" className="btn" onClick={bajar} disabled={disabled}>
      <Icon name="download" /> Exportar a Excel
    </button>
  );
}

/** Nombre de archivo con el periodo: reporte-casos-2026-10-01-a-2026-10-27. */
export const nombrePeriodo = (base: string, desde: Date, hasta: Date) => {
  const d = (x: Date) => `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
  return `${base}-${d(desde)}-a-${d(new Date(hasta.getTime() - 1))}`;
};
